import includes from 'lodash/includes';
import { appContext } from './app-context';

export const isFeatureEnabled = (featureName) => includes(appContext.user.features, featureName);
